import translations from './translations'

translations.add('is', {
    changePaymentMethod: 'breyta greiðslumáta',
    firstTokenizationDescription: 'Kortaskráning',
    firstVerificationDescription: 'Staðfesting korts',
    secondaryOrderInfoDescription: 'Kortið þitt verður ekki gjaldfært',
    tryAgain: 'Reyndu aftur'
})
